import React from 'react';
import { IAuditoriaArredondamentosAjustesResultado } from '../interfaces/IAuditoriaArredondamentosAjustes';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaArredondamentosAjustesResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Arredondamentos e Lançamentos de Ajustes — não é um tributo, é uma auditoria
// complementar que varre todo o livro (Ativo, Passivo, Resultado) procurando lançamentos cujo
// histórico cite "ajuste" ou "arredondamento" (Art. 12, II, Lei 8.218/1991; CPC 00 — Fidedignidade).
const AuditoriaResumoArredondamentosAjustes: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.lancamentosAjuste?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Arredondamentos e Lançamentos de Ajustes</h3>
      <p className='text-muted'>
        Auditoria complementar — lançamentos com histórico citando "ajuste" ou "arredondamento" configuram risco de
        não conciliação, com inexatidão de escrituração no SPED Contábil (Art. 12, II, Lei 8.218/1991). Clique para
        ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              {/* COR-228: renomeado — este módulo só calcula multa acessória de escrituração
                  (Art. 12, II, Lei 8.218/1991), nunca tributo devido. */}
              <th className='text-end'>Multa ECD Estimada</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ARREDONDAMENTOS_AJUSTES')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Arredondamentos e Lançamentos de Ajustes</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} lançamento{totalOcorrencias === 1 ? '' : 's'} de ajuste/arredondamento identificado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD 5%, limitada a 1% da RB (Art. 12, II, Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoArredondamentosAjustes;
